import { render, staticRenderFns } from "./AVAXBalanceTableSummary.vue?vue&type=template&id=4fbb3b5c&scoped=true&"
import script from "./AVAXBalanceTableSummary.vue?vue&type=script&lang=ts&"
export * from "./AVAXBalanceTableSummary.vue?vue&type=script&lang=ts&"
import style0 from "./AVAXBalanceTableSummary.vue?vue&type=style&index=0&id=4fbb3b5c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbb3b5c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
